import React from 'react';
import AppNav from '../AppNav';

// AccountScreenBanner — new (Sep 8, per Ali's report). Every account
// settings sub-screen (Change Password, Change Email, Notifications,
// Delete Account) was missing the top navy bar every other screen in
// the app has — the exact same gap FreezeDetailScreen.js had before
// its own Aug 17 fix (see that file's comment on this), just showing
// up again in a newer set of screens. Extracted as one shared
// component rather than copy-pasting the same banner into 4 files,
// since a future account screen should get this for free.
//
// Deliberately NOT retrofitted onto Dashboard.js/FreezeDetailScreen.js/
// DealScreen.js's own existing, separately-styled banners — those
// already work, and folding already-shipped screens into a shared
// component wasn't part of what was asked here.
//
// section prop dropped from the render (Sep 8, per Ali's report — real
// redundancy, confirmed via screenshot: the page's own H1 already says
// "Set a new password" etc., so pairing a second static label right
// next to the nav's back-link was duplicate information sitting next
// to the one functional element that actually does something). Left
// in the function signature rather than removed from every caller —
// harmless to keep passing, just no longer rendered.
function AccountScreenBanner() {
  return <AppNav current="account" />;
}

export default AccountScreenBanner;
